const IconActionButton = ({title, disabled = false, onClick, className = '', children}) => (
    <button
        type="button"
        title={title}
        onClick={() => !disabled && onClick?.()}
        disabled={disabled}
        className={`inline-flex items-center justify-center ${className} ${disabled ? 'opacity-35 cursor-not-allowed' : 'cursor-pointer hover:opacity-80'}`}
    >
        {children}
    </button>
);

export default IconActionButton;